import __base_store from '@/store/__base_store'

/**
 * Store de rutas de receta.
 */
export default __base_store({
	state: {
		model_name: 'recipe_route',
	},
})

